import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from '../../styles/printFont/vfs_fonts2';
import helper from "actions/helper";

const Print = async (infoPrint) => {
    const { vfs } = pdfFonts.pdfMake;
    pdfMake.vfs = vfs;

    pdfMake.fonts = {
        Roboto: {
            normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
            bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
            italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
            bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
        },
    };

    let totalSumR = 0;
    let totalSumA = 0;
    let text1 = "Сроки предоставления конкретных услуг зависят от состояния здоровья пациента, ";
    text1 += "графика визитов пациента, расписания работы врача, иных обстоятельств и могут быть скорректированы.";
    let text2 = "Настоящий план является предварительным и может быть изменен по согласованию с пациентом в соответствии с медицинскими показаниями, ";
    text2 += "состоянием здоровья пациента, результатами обследований и иными факторами.";
    let text3 = "Отказ пациента от получения медицинских услуг по настоящему плану лечения (полный или частичный), ";
    text3 += "в том числе в связи с несогласием пациента с предложенными врачом изменениями в план лечения, ";
    text3 += "обусловленными медицинскими показаниями или иными объективными обстоятельствами, ";
    text3 += "является отказом Пациент от получения медицинских услуг по Договору. ";
    text3 += "В этом случае оказание услуг приостанавливается до согласования Сторонами нового плана лечения.";
    let text4 = "Указанная стоимость услуг рассчитана исходя из Прайс-листа Исполнителя, ";
    text4 += "действующего на дату составления настоящего плана лечения, и является актуальной при условии оплаты услуг путем ";
    text4 += "100% предоплаты стоимости услуг до их оказания (авансового платежа) и неизменности плана лечения. ";
    text4 += "Если пациент оплачивает услуги после их предоставления, то стоимость услуг определяется на основании ";
    text4 += "Прайс-листа Исполнителя, действующего на момент оплаты услуг.";
    let text5 = "Услуги, прямо не указанные в настоящем документе, в данный план не включены и оплачиваются отдельно согласно Прайс-листа, действующему на момент оплаты услуг.";

    const getTable = (plan) => {
        const body = [
            [
                /*{ text: "Зуб", bold: true },*/
                { text: "Наименование работы (услуги)/Зуб", bold: true },
                { text: "Кол-во", bold: true },
                { text: "Цена за единицу, рубли", bold: true },
                { text: "Стоимость, рубли", bold: true }
            ]
        ];

        plan?.preSecuredInvoice?.securedInvoiceItems.sort((a, b) => a.sortIndex - b.sortIndex).forEach(row => {
            const sum = helper.number.toSum(helper.number.percentMinus(row.count * row.price, row.discount));
            const price = helper.number.toSum(row.price);
            const teeths = (helper.getTeethNames(row.teeth) || []).join(", ");
            body.push([`${row.title} / ${teeths}`, row.count, price, sum]);
        });

        body.push([
            {
                colSpan: 4,
                text: `Срок действия этапа: ${helper.date.toStr(plan.intendedTreatmentDate, "DD.MM.YYYY")}`,
                bold: true,
                margin: [0, 5, 0, 0]
            },
            {}, {}, {}
        ]);

        const sum = plan?.preSecuredInvoice?.totalSum;
        body.push([
            {
                colSpan: 3,
                text: `ИТОГО`,
                alignment: 'right',
                bold: true,
                margin: [0, 0, 0, 0]
            },
            {}, {},
            helper.number.toSum(sum)
        ]);

        /*const table = {
            widths: [60, "*", 40, 80, 70],
            body,
        };*/
        const table = {
            widths: ["*", 40, 80, 70],
            body,
        };

        return { table, margin: [0, 0, 0, 15], unbreakable: true, };
    };

    const formTreatmentDetails = (treatmentTasks, title) => {
        const treatmentDetails = [];

        treatmentTasks.filter(it => title === "Рекомендованное лечение" ? (it.type === "RECOMMENDER") : it.type !== "RECOMMENDER")
            .filter(it => it.agreed)
            .forEach((it, i) => {
                const table = getTable(it);

                const stack = [];

                if (i === 0)
                    stack.push({
                        style: 'doctor',
                        text: title,
                        bold: true,
                    });

                stack.push({
                    style: 'doctor',
                    text: `Этап №${i + 1} - ${it.title}`,
                    bold: true,
                    margin: [0, 0, 0, 5] // немного отступа от заголовка до таблицы
                });
                stack.push(table);

                treatmentDetails.push({
                    unbreakable: true,
                    stack
                });

                const sum = it?.preSecuredInvoice?.totalSum ? it.preSecuredInvoice.totalSum : 0;

                if (it.type === "RECOMMENDER")
                    totalSumR += sum;
                else
                    totalSumA += sum;
            });

        return treatmentDetails;
    };

    const formTreatment = (type) => {
        const { treatmentTasks } = infoPrint;
        let treatment = [];

        if (type === "recomm" && treatmentTasks.some(it => it.type === "RECOMMENDER"))
            treatment = formTreatmentDetails(treatmentTasks, "Рекомендованное лечение");
        else if (type === "alter" && treatmentTasks.some(it => it.type !== "RECOMMENDER"))
            treatment = formTreatmentDetails(treatmentTasks, "Альтернативное лечение");

        return treatment;
    };

    const checkExistTreatment = () => {
        const { treatmentTasks } = infoPrint;
        let req = {};
        if (!treatmentTasks.some(it => it.agreed)) {
            req = {
                style: 'doctor',
                text: "Нет согласованных этапов!",
                bold: true,
            };
        }


        return req;
    };

    const formPage = (it) => {

        const page = [
            {
                style: 'header2',
                text: [{ text: "ПРЕДВАРИТЕЛЬНЫЙ ПЛАН ЛЕЧЕНИЯ", bold: true }]
            },
            {
                style: 'client',
                text: [
                    "Пациент: ",
                    { text: `${it.fio} ${it?.birthday ? "(" + helper.date.toStr(it.birthday, "DD.MM.YYYY") + ")" : ""}`, bold: true, },
                ]
            },
            {
                style: 'doctor',
                text: [
                    "Лечащий врач: ",
                    { text: it.doctor, bold: true, },

                ]
            },
            ...formTreatment("recomm"),
            ...formTreatment("alter"),
        ];

        return page;
    };

    const getTotalSum = () => {
        const t = [{
            text: [
                "Стоимость ",
                { text: "рекомендованных", bold: true },
                " медицинских услуг составляет: ",
                { text: `${helper.number.toSum(totalSumR)} `, bold: true },
                ", без НДС."
            ]
        }];

        if (totalSumA)
            t.push({
                text: [
                    "Стоимость ",
                    { text: "альтернативных", bold: true },
                    " медицинских услуг составляет: ",
                    { text: `${helper.number.toSum(totalSumA)} `, bold: true },
                    ", без НДС."
                ]
            });

        return t;
    };

    const getProperty = () => {
        const { clinic } = infoPrint;
        const { organisationName, address, license, phone, city } = clinic;
        const lic = license.split(' от ')[0];
        const add = city.name + " " + address;
        const ph = "Тел: " + helper.inputValidators.phone(phone);

        return { organisationName, lic, add, ph };
    };

    const property = getProperty();

    const documentDefinition = {
        pageSize: 'A4',
        content: [
            {
                style: 'header',
                table: {

                    widths: ['*', 150],
                    body: [
                        [
                            property.organisationName,
                            "Приложение"
                        ],
                        [
                            property.lic,
                            "к Договору об оказании"
                        ],
                        [
                            property.add,
                            "платных медицинских услуг"
                        ],
                        [
                            property.ph,
                            `№ ${infoPrint.profileNumber} от ${helper.date.toStr(infoPrint.dateRegistration, "DD.MM.YYYY")}`
                        ],
                    ],
                },
                layout: 'noBorders'
            },
            ...formPage(infoPrint, property),
            checkExistTreatment(),
            ...getTotalSum(),
            {
                text: [
                    "",
                ],
                margin: [0, 0, 0, 15]
            },
            {
                table: {
                    widths: ["*"],
                    body: [
                        ["Сроки предоставления услуг по настоящему плану лечения: "],
                        ["Этап 1 – ____ (_________) месяцев. "],
                        ["Этап 2 – ____ (_________) месяцев. "],
                        ["Этап 3 – ____ (_________) месяцев. "],
                        ["Сроки предоставления услуг по настоящему плану лечения: _____________ месяцев."],
                    ]
                },
                layout: 'noBorders',
                margin: [0, 0, 0, 15]
            },
            {
                text: "Своей подписью в настоящем документе пациент (законный представитель пациента) подтверждает, что ему разъяснено и понятно следующее: "
            },
            {
                table: {
                    widths: [15, "*"],
                    body: [
                        ["1.", text1],
                        ["2.", text2],
                        ["3.", text3],
                        ["4.", text4],
                        ["5.", text5],
                    ]
                },
                layout: 'noBorders'
            },
            {
                text: [
                    "Я понимаю, что должен(на) незамедлительно информировать лечащего врача ",
                    "обо всех случаях возникновения аллергии, перенесенных ранее заболеваниях, ",
                    "как острых, так и хронических (в том числе о хирургических операциях, ",
                    "наличии сахарного диабета, онкологических заболеваниях), травмах, ",
                    "а также о принимаемых лекарственных средствах и биоактивных добавках, ",
                    "непереносимости лекарственных препаратов и ее проявлениях, ",
                    "сообщать правдивые сведения о наследственности, ",
                    "а также употреблении алкоголя, наркотических и токсических средствах, курении, ",
                    "высказывать все жалобы."
                ],
                margin: [0, 0, 0, 10]
            },
            {
                text: [
                    "Неявка на приём к врачу в согласованные сроки, ",
                    "невыполнение рекомендаций врача или выполнение их не в полном объёме, ",
                    "приводит к увеличению сроков лечения ",
                    "и как следствие, увеличению стоимости лечения."
                ],
                margin: [0, 0, 0, 10]
            },
            {
                text: [
                    "Я понимаю значение гигиены полости рта для успешного лечения ",
                    "и обязуюсь выполнять все назначения, включая использование ирригатора полости рта ",
                    "и медицинских изделий, рекомендованных врачом."
                ],
                margin: [0, 0, 0, 10]
            },
            {
                text: [
                    "В соответствии с положениями Закона № 323-ФЗ пациент обязан заботиться о сохранении своего здоровья. ",
                    "Я согласен(на) тщательно и скрупулёзно выполнять рекомендации врача в процессе лечения, ",
                    "понимая, что невыполнение или ненадлежащее их выполнение чревато ухудшением возможного результата. ",
                    "Ответственность за неблагоприятный исход лечения в случае невыполнения/неполного выполнения ",
                    "рекомендаций врача ложится на меня."
                ],
                margin: [0, 0, 0, 10]
            },
            {
                text: [
                    "Я внимательно ознакомился(лась) с данным документом, ",
                    "имеющим юридическую силу и являющимся неотъемлемой частью ",
                    "моей медицинской карты и договора возмездного оказания стоматологических услуг."
                ],
                margin: [0, 0, 0, 10]
            },
            {
                text: [
                    "С планом лечения ознакомлен(а) и согласен(-на).",
                ],
                bold: true,
                margin: [0, 0, 0, 10]
            },
            {
                text: [
                    "Пациент/Законный представитель пациента:",
                ],
                decoration: 'underline',
                bold: true,
                margin: [0, 0, 0, 10]
            },
            {
                text: [
                    "Дата: «____»______20____ года ",
                ],
                margin: [0, 0, 0, 10]
            },
            {
                text: [
                    "Подпись:_________________/________________________________________________________________/",
                ],
            },

        ],
        styles: {
            header: {
                fontSize: 9,
                lineHeight: 0.7,
                margin: [0, 10, 0, 20]
            },
            header2: {
                fontSize: 12,
                alignment: 'center',
                margin: [0, 0, 0, 15]
            },
            client: {
            },
            doctor: {
                margin: [0, 0, 0, 15]
            },
            table: {
                fontSize: 9,
            },
            itogo: {
                fontSize: 12,
                margin: [0, 15, 0, 15]
            },
            itogoTable: {
            },
            itogoTable2: {
            },
            signTable: {
                margin: [0, 20, 0, 0]
            },
        },
        defaultStyle: {
            fontSize: 10,
        }
    };

    pdfMake.createPdf(documentDefinition).open();

};

export default Print;
